// extracted by mini-css-extract-plugin
export default {"infinite-scroll-load-more-spinner-wrapper":"styles_infinite-scroll-load-more-spinner-wrapper__dghfN"};